import template from './delivery_region_routing.all.html';
import controller from './delivery_region_routing.all.controller';
import './delivery_region_routing.all.scss';

let deliveryRegionRoutingAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
}

export default deliveryRegionRoutingAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/all/delivery_region_routing.all.component.js